module.exports = __webpack_public_path__ + "img/Algeria.5cf1a9cf.gif";